export enum Entity {
  Tool = 'Tool',
  ToolUseCase = 'ToolUseCase',
  Metric = 'Metric',
  MetricUseCase = 'MetricUseCase'
}
